import React from 'react';

import { useContext } from 'components/Managers/Billing/Context';
import Policy from './Policy';
import NoPolicy from './NoPolicy';

export default function Index() {
  const { state } = useContext();

  return (
    <section>

      {state.policyEnabled ? <Policy /> : <NoPolicy />}
    </section>
  );
}
